import React, { useEffect, useState } from 'react';
import '../../styles/AdminPopupTab.css';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export default function AdminPopupTab() {
  const [items, setItems] = useState([]);
  const [msg, setMsg] = useState('');

  // ✅ 팝업 전용 초기 폼 (다국어 및 활성화 상태 포함)
  const initialForm = {
    id: 0,
    title_kr: '', title_en: '', title_jp: '', title_ch: '',
    content_kr: '', content_en: '', content_jp: '', content_ch: '',
    link_url: '',
    is_active: 0, // 0: 비활성, 1: 활성
    image_url: ''
  };

  const [f, setF] = useState(initialForm);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  async function load() {
    try {
      const res = await fetch(`${API_BASE}/api/popup_list.php`, { credentials: 'include' });
      const data = await res.json();
      if (!res.ok) { setMsg(data?.error || 'Failed to load'); return; }
      setItems(Array.isArray(data) ? data : []);
    } catch (e) { setMsg('서버 연결 오류'); }
  }

  useEffect(() => { load(); }, []);

  const showMsg = (text) => {
    setMsg(text);
    setTimeout(() => setMsg(''), 3000);
  };

  const openCreateModal = () => {
    setIsEditMode(false);
    setF(initialForm);
    setSelectedFile(null);
    setShowModal(true);
  };

  const startEdit = (item) => {
    setIsEditMode(true);
    setF({ ...item, is_active: Number(item.is_active) }); // 숫자로 확실히 변환
    setSelectedFile(null);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setF(initialForm);
    setSelectedFile(null);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    
    // 모든 필드 FormData 추가
    Object.keys(f).forEach(key => formData.append(key, f[key] ?? ''));
    if (selectedFile) formData.append('image_file', selectedFile);

    const url = isEditMode 
      ? `${API_BASE}/api/admin_popup_update.php` 
      : `${API_BASE}/api/admin_popup_create.php`;

    try {
      const res = await fetch(url, {
        method: 'POST', credentials: 'include', body: formData
      });
      const data = await res.json();
      if (!res.ok) return showMsg(data.error || '저장 실패');
      
      showMsg(isEditMode ? 'Updated ✅' : 'Saved ✅');
      closeModal();
      load();
    } catch (e) { showMsg('서버 오류'); }
  }

  async function del(id) {
    if (!window.confirm('팝업 설정을 삭제하시겠습니까?')) return;
    const res = await fetch(`${API_BASE}/api/admin_popup_delete.php`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      credentials: 'include', body: JSON.stringify({ id })
    });
    if (!res.ok) return showMsg('삭제 실패');
    showMsg('Deleted ✅');
    load();
  }

  return (
    <div className="admin-tab-content">
      {msg && <div className={`admin-toast ${msg.includes('✅') ? 'success' : 'error'}`}>{msg}</div>}

      <div className="admin-list-header">
          <button onClick={openCreateModal} className="admin-btn primary">+ NEW POPUP</button>
      </div>

      <div className="admin-grid single-col">
        <main className="admin-main-list">
          <section className="admin-card">
            <div className="card-head">
              <h3>POPUP SETTINGS</h3>
              <span className="card-dot"></span>
            </div>
            <div className="admin-list-container">
              <div className="list-items">
                {items.map(it => (
                  <div key={it.id} className={`admin-item-row compact ${it.is_active === 1 ? 'active' : ''}`}>
                    <div className="item-main-grid">
                      <div className="item-thumb-box">
                        {it.image_url ? (
                          <img src={`${API_BASE}${it.image_url}`} alt="popup" className="item-thumb" />
                        ) : (
                          <div className="item-thumb-empty">P</div>
                        )}
                      </div>
                      <div className="item-body">
                        <div className="item-header-meta">
                          <span className={`item-type-badge ${it.is_active === 1 ? 'active' : ''}`}>
                            {it.is_active === 1 ? 'ON AIR' : 'OFF'}
                          </span>
                          <span className="item-year">{it.updated_at?.split(' ')[0]}</span>
                        </div>
                        <p className="item-title">{it.title_kr}</p>
                        <p className="item-role">{it.content_kr?.substring(0, 30)}...</p>
                      </div>
                      <div className="item-actions-side">
                        <button onClick={() => startEdit(it)} className="action-btn edit">EDIT</button>
                        <button onClick={() => del(it.id)} className="action-btn del">DEL</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>
      </div>

      {/* --- 팝업 전용 모달 --- */}
      {showModal && (
        <div className="admin-modal-overlay">
          <div className="admin-card modal-card">
            <div className="card-head">
              <h3>{isEditMode ? 'EDIT POPUP' : 'NEW POPUP'}</h3>
              <button onClick={closeModal} className="close-btn">&times;</button>
            </div>
            
            <form onSubmit={handleSubmit} className="admin-form">
              {/* 상태 및 링크 설정 */}
              <div className="form-section-title">BASIC SETTINGS</div>
              <div className="input-row">
                <div className="input-group">
                  <label>Display Status</label>
                  <select value={f.is_active} onChange={e => setF({ ...f, is_active: Number(e.target.value) })}>
                    <option value={0}>OFF (숨김)</option>
                    <option value={1}>ON (노출)</option>
                  </select>
                </div>
                <div className="input-group">
                  <label>Link URL (Optional)</label>
                  <input value={f.link_url} onChange={e => setF({ ...f, link_url: e.target.value })} placeholder="https://..." />
                </div>
              </div>

              {/* 다국어 제목 섹션 (2행 2열 배치) */}
              <div className="form-section-title">TITLES (ALL LANGUAGES)</div>
              <div className="input-row">
                <div className="input-group">
                  <label>Title (KR) *</label>
                  <input value={f.title_kr} onChange={e => setF({ ...f, title_kr: e.target.value })} required placeholder="한국어 제목" />
                </div>
                <div className="input-group">
                  <label>Title (EN)</label>
                  <input value={f.title_en} onChange={e => setF({ ...f, title_en: e.target.value })} placeholder="English Title" />
                </div>
              </div>
              <div className="input-row">
                <div className="input-group">
                  <label>Title (JP)</label>
                  <input value={f.title_jp} onChange={e => setF({ ...f, title_jp: e.target.value })} placeholder="日本語 タイトル" />
                </div>
                <div className="input-group">
                  <label>Title (CH)</label>
                  <input value={f.title_ch} onChange={e => setF({ ...f, title_ch: e.target.value })} placeholder="中文 标题" />
                </div>
              </div>

              {/* 다국어 내용 섹션 (2행 2열 배치) */}
              <div className="form-section-title">CONTENTS (ALL LANGUAGES)</div>
              <div className="input-row">
                <div className="input-group">
                  <label>Content (KR)</label>
                  <textarea value={f.content_kr} onChange={e => setF({ ...f, content_kr: e.target.value })} rows="3" placeholder="한국어 설명" />
                </div>
                <div className="input-group">
                  <label>Content (EN)</label>
                  <textarea value={f.content_en} onChange={e => setF({ ...f, content_en: e.target.value })} rows="3" placeholder="English Description" />
                </div>
              </div>
              <div className="input-row">
                <div className="input-group">
                  <label>Content (JP)</label>
                  <textarea value={f.content_jp} onChange={e => setF({ ...f, content_jp: e.target.value })} rows="3" placeholder="日本語 説明" />
                </div>
                <div className="input-group">
                  <label>Content (CH)</label>
                  <textarea value={f.content_ch} onChange={e => setF({ ...f, content_ch: e.target.value })} rows="3" placeholder="中文 说明" />
                </div>
              </div>

              {/* 이미지 설정 섹션 */}
              <div className="form-section-title">VISUAL SETTINGS</div>
              <div className="input-group">
                <label>{isEditMode ? 'Change Image' : 'Popup Image (Required)'}</label>
                <div className="file-upload-wrapper">
                  <input type="file" onChange={e => setSelectedFile(e.target.files[0])} accept="image/*" className="file-input" />
                  {isEditMode && f.image_url && (
                    <div className="current-file-info">
                      <span className="info-badge">EXISTING</span>
                      <small>{f.image_url.split('/').pop()}</small>
                    </div>
                  )}
                </div>
              </div>

              {/* 하단 버튼 제어 */}
              <div className="form-actions" style={{marginTop: '30px', display: 'flex', gap: '10px'}}>
                <button type="submit" className="admin-btn primary" style={{flex: 1}}>
                  {isEditMode ? 'UPDATE POPUP' : 'CREATE POPUP'}
                </button>
                <button type="button" onClick={closeModal} className="admin-btn secondary" style={{flex: 1}}>
                  CANCEL
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}